import { useEffect } from 'react';
import SlideOverAddCompany from 'components/SlideOver/dataSlideOver/data/slideOverCompany/slideOverAddCompany';
import UseContext from 'hooks/useContext';

export const COMPLETE_CLIENT_PANEL = 'complete_client';

/**
 * « Compléter la fiche client » (slide-over `complete_client`): « Passer
 * client » on a prospect's page opens the form of a client company on it
 * (`objID`), filled with what the prospect has. Every field the creation asks
 * for must be filled before « Passer en client ».
 */
const CompleteClientPanel = () => {
  const { objID, setMissionAfterClient } = UseContext();
  // « Compléter le profil » before a mission (CompleteClientForMissionDialog)
  // lasts as long as this panel: closed in any way, a later « Passer client »
  // opens no mission form.
  useEffect(() => () => setMissionAfterClient(null), [setMissionAfterClient]);
  return (
    <SlideOverAddCompany completeCompanyId={objID ? String(objID) : null} />
  );
};

export default CompleteClientPanel;
